import React, { useCallback, useMemo, useState } from 'react';
import Allocation from './Allocation';

function Allocations({
  allocations,
  rows,
  dropRows,
  canvasRef,
  parentRef,
  styles,
  readOnly,
  onAllocationDatesChange,
  onAllocationDrop,
  onView,
  onEdit,
  onClone,
  onSplit,
  onSplitByDay,
  onSplitByWeek,
  onSplitByMonth,
  onRemoveOverlapping,
  onDelete,
}) {
  // Keep the dragged bar rendered even when auto-scroll pushes its row out of the virtual window.
  const [activeDragId, setActiveDragId] = useState(null);
  const handleDragActive = useCallback((id, active) => {
    setActiveDragId((current) => (active ? id : current === id ? null : current));
  }, []);

  const virtualAllocations = useMemo(() => {
    const indexes = {
      start: rows[0].meta.index,
      end: rows[rows.length - 1].meta.index,
    };

    const virtualAllocations = allocations.filter(
      (allocation) => allocation.meta.rowIndex >= indexes.start && allocation.meta.rowIndex <= indexes.end,
    );

    if (activeDragId && !virtualAllocations.some((allocation) => allocation.id === activeDragId)) {
      const dragged = allocations.find((allocation) => allocation.id === activeDragId);
      if (dragged) virtualAllocations.push(dragged);
    }

    return virtualAllocations;
  }, [allocations, rows, activeDragId]);

  return virtualAllocations.map((allocation) => {
    return (
      <Allocation
        key={allocation.id}
        allocation={allocation}
        canvas={canvasRef}
        dateWidth={styles.date.width}
        rows={dropRows}
        parentRef={parentRef}
        readOnly={readOnly}
        onDragActiveChange={handleDragActive}
        onView={onView}
        onEdit={onEdit}
        onClone={onClone}
        onSplit={onSplit}
        onSplitByDay={onSplitByDay}
        onSplitByWeek={onSplitByWeek}
        onSplitByMonth={onSplitByMonth}
        onRemoveOverlapping={onRemoveOverlapping}
        onDelete={onDelete}
        onDrop={onAllocationDrop ?? onAllocationDatesChange}
        onResize={onAllocationDatesChange}
      />
    );
  });
}

export default React.memo(Allocations);
